import MainLayout from '@/shared/Layouts/MainLayout'
import css from './parameters.module.css'
import NavigationBreadcrumbs from 'src/navigation/components/NavigationBreadcrumbs'
import { useState } from 'react'
import Tabs from '@/shared/Tabs'
import ParameterCalculatedTab from './ParameterCalculatedTab'
import ParameterTab from './ParameterTab'
import { TParameterCardTab } from './parameters.types'
import parameterPageConstants from './parameterPage.constants'
import useTitle from '@/shared/hooks/useTitle'

const ParametersPage = () => {
  useTitle('Переменные')
  const [selectedTab, setSelectedTab] = useState<TParameterCardTab>('parameterTab')

  const renderContent = () => {
    switch (selectedTab) {
      case 'parameterTab':
        return <ParameterTab />
      case 'parameterCalculatedTab':
        return <ParameterCalculatedTab />
    }
  }

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div>
            <h2 className="text-heading-3">Переменные</h2>
          </div>
          <div className={css.mainCard}>
            <div>
              <Tabs tabs={parameterPageConstants.cardTabs} onSelect={setSelectedTab as any} selectedTab={selectedTab} />
            </div>
            {renderContent()}
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default ParametersPage
